jQuery(document).ready(commonInit);

function commonInit() {
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupBanner();
	setupHero();
	setupZipModal();
	setupFancyFocus();
	setupSeekHelp();
	setupScrollTriggers();
	
}

function setupSeekHelp() {
	jQuery('li.seek-help a').on('click', function(e) {
		var userZip = localStorage.getItem("user-zip");
		if (!userZip) {
			return; // Let the default link behavior happen if no zip code
		}

		e.preventDefault();
		var defaultUrl = jQuery(this).attr('href');

		jQuery.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: 'POST',
			data: {
				action: 'get_user_cacs',
				'user-zip': userZip,
				style: 'minimal',
				'single': true
			},
			success: function(result) {
				if (result && result.redirect_url) {
					window.location.href = result.redirect_url;
				} else {
					window.location.href = defaultUrl;
				}
			},
			error: function() {
				window.location.href = defaultUrl;
			}
		});
	});
}

function setupMobileMenu() {
	
	jQuery("#mobile-nav").mmenu({
		"slidingSubmenus": false,
		"offCanvas": {
			"position": "bottom"
		},
		"navbar":{
			"add": false
		}
	}, {
	
		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
		}
	});
	
}

function setupColumns() {
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupBanner() {
	
	var banner = document.getElementById('global-alert');
	var closeButton = document.getElementById('close-alert');
	var html = document.getElementsByTagName('html')[0];
	
	if (!banner || !html) {
		return false;
	}
	
	var bannerHasBeenClosed = sessionStorage.getItem('bannerHasBeenClosed');
	
	if (!bannerHasBeenClosed) {
		html.classList.add('enable-global-alert');
	}
	
	if (closeButton) {
		closeButton.addEventListener('click', function() {
			html.classList.remove('enable-global-alert');
			sessionStorage.setItem('bannerHasBeenClosed', true);
		});
	}
	
}

//usage: var first = getUrlVars()['id'];
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname) {
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;


function setupHero() {

	if(jQuery('#hero-carousel:not(.slick-initialized)').length) {

		jQuery('#hero-carousel:not(.slick-initialized)').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 1,
			slidesPerRow: 1,
			dots: false,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 10000,
			fade: true,
			easing: "linear",
			pauseOnHover: false,
			infinite: true,
			draggable: false,
			swipe: true,
			adaptiveHeight: false
		});
	
	}

}


function setupZipModal() {
	
	var userZip = localStorage.getItem("user-zip");
	var zipModalWasClosed = localStorage.getItem("zip-modal-was-closed");
	var modalContainer = jQuery('div[data-remodal-id="zip"]');
	var modal = modalContainer.remodal();
	
	if(!userZip && !zipModalWasClosed) {
		
		setTimeout(function(){
			
			modal.open();
			jQuery("input#zip").focus();
			
		}, 1000);
		
	} else {
		
		if(userZip) {
			jQuery("#zip-box .content").html("Zip code: " + userZip);
		} else {
			jQuery("#zip-box .content").html("<a data-remodal-target='zip'>Enter Zip code</a>");
			jQuery("#remove-zip").addClass("hide");
		}
		
		jQuery("#zip-box").removeClass("hide");
		
	}

	jQuery(document).on('closed', '.remodal', function(e){
		localStorage.setItem("zip-modal-was-closed", true);
		//location.reload();
		jQuery("#zip-box .content").html("<a data-remodal-target='zip'>Enter Zip code</a>");
		jQuery("#remove-zip").addClass("hide");
		jQuery("#zip-box").removeClass("hide");
	});
	
	jQuery(document).on('opening', '.remodal', function(e){
		localStorage.removeItem("zip-modal-was-closed");
	});
	
	jQuery("#zip-box .content a").on("click", function(){
		setTimeout(function(){
			jQuery("input#zip").focus();
		}, 100);
		console.log("test");
	});
	
	jQuery("#zip-form").submit(function(e){
		
		e.preventDefault();
		
		var zip = jQuery("#zip").val();
		
		localStorage.setItem("user-zip", zip);
		
		location.reload();
		
	});
	
	jQuery("#remove-zip").on("click", function(){
		
		localStorage.removeItem("user-zip");
		
		location.reload();
		
	});
	
}

function setupFancyFocus(){	
	var formElements = jQuery('input, textarea, select');
	formElements.on('focus', function(){
		jQuery(this).closest(".gfield, .gform-grid-col").addClass('focus');
	});
	formElements.on('blur', function(){
		var listItem = jQuery(this);
		if (!listItem.val()) 
		{
			listItem.closest(".gfield, .gform-grid-col").removeClass('focus');
		}
		
	});
}

function setupScrollTriggers(){

	const elements = document.querySelectorAll('.scroll-alert:not(.set-up)');
	
	if ('IntersectionObserver' in window) {
	
		const options = {
			root: null,
			rootMargin: '0px 0px -10% 0px',
			threshold: 0
		};
		
		var observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('active');
				}
			});
		}, options);
		
		elements.forEach(element => {
			element.classList.add('set-up');
			observer.observe(element);
		});
		
	} else {
		
		for(var i=0; i<elements.length; i++) {
			elements[i].classList.add('set-up');
			elements[i].classList.add('active');	
		}
		
	}

}
